module.exports = __webpack_public_path__ + "img/jam04.5919a6a5.jpg";